import { render, staticRenderFns } from "./catalogues.vue?vue&type=template&id=75d50f82&"
import script from "./catalogues.vue?vue&type=script&lang=js&"
export * from "./catalogues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports